export default __webpack_public_path__ + "static/media/training4.dfff39e3.jpg";